import React from 'react';
import { useStore } from '@cobuildlab/react-simple-state';
import {  deletePairDialogStore } from '../pair-stores';
import { MuiDialog } from '../../../shared/components/dialog/MuiDialog';
import { deletePairDialogStoreAction } from '../pair-actions';
import {
  StrategiesDocument,
  useDeleteStrategyMutation,
} from '../../../shared/types/generated';
import { useMetaCloudHook } from '../../meta-api-cloud/meta-api-cloud-hooks';

type DeletePairDialogProps = {
  onSuccess?: () => void;
}

export const DeletePairDialog: React.FC<DeletePairDialogProps> = (
  {
    onSuccess,
  }) => {
  const { open, pair } = useStore(deletePairDialogStore);
  const { connection } = useMetaCloudHook();

  const handleClose = (): void => {
    deletePairDialogStoreAction({ open: false, pair: undefined });
  };

  const [deleteStrategy, { loading }] = useDeleteStrategyMutation({
    awaitRefetchQueries: true,
    refetchQueries: [StrategiesDocument],
    onCompleted: () => {
      connection?.unsubscribeFromMarketData(pair?.symbol as string, []);
      handleClose();
      if (onSuccess) onSuccess();
    },
  });

  return <MuiDialog
    open={Boolean(open)}
    handleClose={() => handleClose()}
    loading={loading}
    title='Delete Pair'
    maxWidth='sm'
    handleSuccess={() => {
      deleteStrategy({
        variables: {
          where: {
            id: pair?.id,
          },
        },
      });
    }}
    fullWidth
    renderActions
  >
    Do you want to delete {pair?.symbol} pair?
  </MuiDialog>;
};